import pub from './../public';
const type = pub.getLang();
const _conf = require('./../js/_conf');
const _pcBase = _conf.env_type == 4 ? 'https://sim.house730.com' : _conf.env_type == 3 ? 'https://www.house730.com' : 'https://uat.house730.com.cn';

const language = {
  'zh-hk': {
    verinfo: '驗證信息',
    email: '電郵地址',
    emailText: '電郵',
    reEmail: '確認電郵',
    telephone: '香港手提電話',
    password: '用戶登入密碼',
    rePassword: '用戶確認密碼',
    nickName: '會員名稱',
    agreeError: '請同意會員條款',
    gender: '性別',
    pleaseSel: '請選擇',
    ageType: '年齡組別',
    salary: '每月個人入息',
    pwdError: '密碼必須為6-20位英文數字組合',
    emailNull: '請填寫你的電郵',
    live: '居所',
    languageType: '選擇語言',
    isPropertyAgent: '本人是持牌地產代理',
    propertyAgent: '地產代理',
    news: '接收通知',
    smsTip: '備註：一般SMS短訊會在數分鐘內發出。如需協助，請聯絡 3619 3200',
    agreement: `已閱讀及同意 <a  href="${_pcBase}/help/servicepolicy/"  target="_blank">House730服務條款</a>`,
    register: '註冊',
    smsCode: '驗證碼',
    enter: '請輸入',
    phoneTag: '你的電話必須能夠接收SMS,系統會將確認碼透過SMS傳送給你',
    companyNameCN: '代理公司名稱',
    companyNameEN: '代理公司名稱(英文)',
    companyTelephone: '代理公司電話',
    companyAddress: '代理公司地址',
    companyAddressEN: '地產代理公司地址(英文)',
    companyLicense: '公司地產代理牌照',
    number: '號碼',
    license: '個人地產代理牌照',
    agentTip: '如閣下是地產代理,請填寫以下資料',
    null: '請填寫',
    differentEmail: '兩次輸入的電郵不一致',
    differentPassword: '兩次輸入的密碼不一致',
    confirmEmail: '請輸入多一次你的電郵',
    confirmPassword: '請輸入多一次登入密碼',
    cancel: '取消',
    save: '確認',
    flow:
      '1）提供會員資料 - 請填妥以下表格。<br>\
    2）確認電郵地址 - 你的電郵信箱會收到「House730確認電郵」，按下電郵內的連結以確認你的電郵地址。<br>\
    3）確認手提電話 - 請前往House730的「新會員確認中心」輸入你的手提電話，隨後你的手提電話會收到一個以SMS發送的驗證碼，請輸入驗證碼以確認你的手提電話。<br>\
    4）會員註冊完成！你可立即登入及使用House730服務。<br>',
    signature: '代理個人署名及介紹',
    select: '請選擇',
    pwdReg: '必須為6－20位英文數字組合',
    emailReg: '電郵格式錯誤',
    inputError: '輸入有誤',
    male: '男',
    female: '女',
    modify: '修改代理信息',
    bread1: '地產主頁',
    bread2: '會員中心',
    regFlow: '免費註冊會員手續',
    regisiter: '登記會員',
    canLogin: '如已登記，請按此登入',
    f_tip: '如你忘記密碼，請輸入已登記的電郵及手提電話，我們稍後會把重設密碼電郵到你登記電郵地址',
    f_title: '忘記密碼',
    f_step: '操作提示',
    f_send: '操作成功,你將會收到一封來自House730的電郵關於密碼找回資訊',
    f_wait: '請稍等',
    f_accountError: '電郵地址與手提電話不符，請重新輸入',
    f_accountExists: '此賬戶不存在',
    f_success: '提交成功，你的郵箱 <a>@</a> 將會收到一封來自House730的電郵，請根據郵件內提示驗證賬戶以保證賬戶正常使用，完成認證後可點擊下方按鈕登入。',
    hasExist: '@@已被註冊',
    newUser: '新會員確認',
    pass: '已通過',
    waitPass: '待確認',
    noPass: '已失效',
    tel: '電話',
    verifyPass: '以上兩項驗證成功，即可在登入頁面直接',
    login: '登入',
    reSend: '重新傳送SMS驗證碼',
    sendMg: '傳送SMS驗證碼',
    setPwd: '請輸入新密碼，確認後新密碼將立即生效',
    resetPwd: '重置密碼',
    link: '驗證失敗，驗證連結已失效，請點擊「重新傳送」按鈕',
    forget_error: '鏈接失效，請點擊下方按鈕重新進行密碼找回操作',
    verCode: '驗證碼',
    set_success: '驗證成功，請點撃此處',
    languageText: '語言',
    telError: '電話格式錯誤',
    verifyCode: '驗證碼',
    agreeSend: '同意接收',
    cantSpace: '不能包括空格',
    linkPhone: '聯絡電話',
    error: '錯誤或已失效',
    accountStatus: '帳戶狀態',
    noTrue: '待確認，請查看你的電郵郵箱驗證你的電郵',
    goLogin: '賬戶登入',
    hasPass: '操作失敗，此帳戶已驗證，無需再次驗證',
    waitSend: '點擊「傳送」按鈕，接收驗證郵件完成帳戶驗證',
    findPwd: '找回密碼',
    reSendEmail: '傳送',
    verifyError: '驗證碼輸入錯誤，請重新輸入',
    networkError: '網絡不穩定,請再嘗試',
    certificate: '地產代理證',
    wepUpdata: '上傳',
    pcUpdata: '上傳圖片',
    imagePath: '圖片',
    promptMessage: '上傳後,地產代理證將無法修改,如需修改請聯絡我們',
    errorImg: '請上傳png，jpg，jpeg格式',
    imgfailure: '地產代理證上傳失敗',
    imgNull:"地產代理證不能為空",
  },
  'zh-cn': {
    verinfo: '验证信息',
    email: '电邮地址',
    emailText: '电邮',
    reEmail: '确认电邮',
    telephone: '香港手提电话',
    password: '用户登入密码',
    rePassword: '用户确认密码',
    nickName: '会员名称',
    agreeError: '请同意会员条款',
    gender: '性别',
    pleaseSel: '请选择',
    ageType: '年龄组别',
    salary: '每月个人入息',
    pwdError: '密码必须为6-20位英文数字组合',
    emailNull: '请填写你的电邮',
    live: '居所',
    languageType: '选择语言',
    isPropertyAgent: '本人是持牌地产代理',
    propertyAgent: '地产代理',
    news: '接收通知',
    smsTip: '备注：一般SMS短讯会在数分钟内发出。如需协助，请联络 3619 3200',
    agreement: `已阅读及同意 <a  href="${_pcBase}/zh-cn/help/servicepolicy/"  target="_blank">House730服务条款</a>`,
    register: '注册',
    smsCode: '验证码',
    enter: '请输入',
    phoneTag: '你的电话必须能够接收SMS,系统会将确认码透过SMS传送给你',
    companyNameCN: '代理公司名称',
    companyNameEN: '代理公司名称(英文)',
    companyTelephone: '代理公司电话',
    companyAddress: '代理公司地址',
    companyAddressEN: '地产代理公司地址(英文)',
    companyLicense: '公司地产代理牌照',
    number: '号码',
    license: '个人地产代理牌照',
    agentTip: '如阁下是地产代理,请填写以下资料',
    null: '请填写',
    differentEmail: '两次输入的电邮不一致',
    differentPassword: '两次输入的密码不一致',
    confirmEmail: '请输入多一次你的电邮',
    confirmPassword: '请输入多一次登入密码',
    cancel: '取消',
    save: '确认',
    flow:
      '1）提供会员资料 - 请填妥以下表格。<br>\
    2）确认电邮地址 - 你的电邮信箱会收到「House730确认电邮」，按下电邮内的连结以确认你的电邮地址。<br>\
    3）确认手提电话 - 请前往House730的「新会员确认中心」输入你的手提电话，随后你的手提电话会收到一个以SMS发送的验证码，请输入验证码以确认你的手提电话。<br>\
    4）会员注册完成！你可立即登入及使用House730服务。<br>',
    signature: '代理个人署名及介绍',
    select: '请选择',
    pwdReg: '必须为6－20位英文数字组合',
    emailReg: '电邮格式错误',
    telError: '电话格式错误',
    inputError: '输入有误',
    male: '男',
    female: '女',
    modify: '修改代理信息',
    bread1: '地产主页',
    bread2: '会员中心',
    regFlow: '免费注册会员手续',
    regisiter: '登记会员',
    f_tip: '如你忘记密码，请输入已登记的电邮及手提电话，我们稍后会把重设密码电邮到你登记电邮地址。',
    f_title: '忘记密码',
    f_step: '操作提示',
    f_send: '操作成功,你将会收到一封来自House730的电邮关于密码找回资讯',
    f_wait: '请稍等',
    f_accountError: '电邮地址与手提电话不符，请重新输入',
    f_accountExists: '此账户不存在',
    f_success: '提交成功，你的邮箱 <a>@</a> 将会收到一封来自House730的电邮，请根据邮件内提示验证账户以保证账户正常使用，完成认证后可点击下方按钮登入。',
    hasExist: '@@已被注册',
    newUser: '新会员确认',
    pass: '已通过',
    waitPass: '待确认',
    noPass: '已失效',
    tel: '电话',
    verifyPass: '以上两项验证成功，即可在登入页面直接',
    login: '登入',
    reSend: '重新传送SMS验证码',
    reSendEmail: '传送',
    sendMg: '传送SMS验证码',
    setPwd: '请输入新密码，确认后新密码将立即生效',
    resetPwd: '重置密码',
    link: '验证失败，验证连结已失效，请点击「重新传送」按钮',
    forget_error: '链接失效，请点击下方按钮重新进行密码找回操作',
    verCode: '验证码',
    set_success: '验证成功，请点撃此处',
    cannLogin: '如已登记，请按此登入',
    languageText: '语言',
    verifyCode: '验证码',
    agreeSend: '同意接收',
    cantSpace: '不能包括空格',
    linkPhone: '联络电话',
    error: '错误或已失效',
    accountStatus: '帐户状态',
    noTrue: '待确认，请查看你的电邮邮箱验证你的电邮',
    goLogin: '账户登入',
    hasPass: '操作失败，此帐户已验证，无需再次验证',
    waitSend: '点击「传送」按钮，接收验证邮件完成帐户验证',
    findPwd: '找回密码',
    verifyError: '验证码输入有误,请重新输入',
    networkError: '网络不稳定,请再尝试',
    certificate: '地产代理证',
    wepUpdata: '上传',
    pcUpdata: '上传图片',
    imagePath: '图片',
    promptMessage: '上传后,地产代理证将无法修改,如需修改请联络我们',
    errorImg: '请上传png，jpg，jpeg格式',
    imgfailure: '地产代理证上传失败',
    imgNull:"地产代理证不能为空",
  },
  'en-us': {
    verinfo: 'verify message',
    email: 'Email',
    emailText: 'E-mail',
    reEmail: 'Re-enter email',
    telephone: 'HK Mobile',
    password: 'Password',
    rePassword: 'Re-enter password',
    nickName: 'Username',
    gender: 'Gender',
    smsCode: 'SMS Code',
    pleaseSel: 'Please select ',
    agreeError: 'Read and agreed with House730 Service Terms and Conditions',
    ageType: 'Age',
    reSendEmail: 'Send',
    salary: 'Monthly Salary',
    pwdError: 'Password must be 6-20 alphanumeric character',
    emailNull: 'Please fill in your email',
    live: 'Live',
    smsTip: 'Remarks: SMS will be sent out within a few minutes. If you need any assistance, please contact 3619 3200',
    languageType: 'Language',
    isPropertyAgent: 'I am a licensed property agent',
    propertyAgent: 'Property Agency',
    news: 'Agree to receive House730 member news',
    agreement: `Read and agreed with <a  href="${_pcBase}/en-us/help/servicepolicy/"  target="_blank">House730 Service Terms and Conditions</a>`,
    register: 'Register',
    goRegister: 'Member Registration',
    enter: 'Please Enter',
    phoneTag: 'Phone verify code will be sent via SMS, please make sure your phone no. could receive SMS',
    companyNameCN: 'Company name(Chi)',
    companyNameEN: 'Company name(Eng)',
    companyTelephone: 'Company phone no.',
    companyAddress: 'Company address',
    companyAddressEN: 'Company Address(English)',
    companyLicense: 'Company License',
    license: 'Personal License',
    agentTip: 'If you are property agent, please fill in the followings',
    null: 'Please fill in ',
    number: 'number',
    differentEmail: 'Email is not match',
    differentPassword: 'Password is not match',
    confirmEmail: '	Please re-enter your email',
    confirmPassword: 'Please re-enter your password',
    cancel: 'Cancel',
    save: 'Submit',
    flow:
      '1) Provide membership information - please fill in the required information below.<br>\
    2）Confirm your email address - Your email box will receive “House730 confirmation email” and please click the hyperlink to confirm your email address.<br>\
    3) Confirm your mobile phone - please go to “New Member Verification” and enter your mobile phone no. Your mobile phone will receive a SMS shortly and please enter the verification code.<br>\
    4) Membership registration is now completed ! You can now login and use House730 service.<br>',
    signature: 'Agent Signature and Description',
    select: 'Please select ',
    pwdReg: ' 6-20 digital character and number',
    emailReg: 'Invalid email format',
    telError: 'Invalid phone format',
    inputError: 'Input Error',
    male: 'Male',
    female: 'Female',
    modify: 'Click here to modify',
    bread1: 'Home',
    bread2: 'Member area',
    regFlow: 'Free Membership Registration Procedure',
    regisiter: 'Member Registration',
    canLogin: 'Click here to login, if you have registered',
    f_tip: 'If you forget password, please enter your registered email and mobile no. A reset password will be email to your registered email address',
    f_title: 'Forget Password',
    f_step: 'Instruction',
    f_send: 'Instruction submitted sucessfully, your email box will receive "Reset Password email"',
    f_wait: 'Please wait',
    f_accountError: 'Email and Mobile No. not match. Please enter again',
    f_accountExists: "Account doesn't exist",
    hasExist: '@@ already registered',
    f_success: 'Your email box <a>@</a> will receive “House730 confirmation email” and please click the hyperlink to confirm your email address',
    newUser: 'New Member Verification',
    pass: 'Passed',
    noPass: 'Expired',
    tel: 'phone',
    verifyPass: 'You have passed 2 verifications, welcome to use House730',
    login: 'login',
    waitPass: 'Pending Verification',
    reSend: 'Re-send SMS verification code',
    sendMg: 'Send SMS verification code',
    setPwd: 'Please enter new password, it will be effective after saved',
    resetPwd: 'Reset Password',
    link: 'Verification failed, verification link is expired, please click Re-send button',
    forget_error: 'The link is invalid, please click the button below to re-create the password',
    verCode: 'SMS verification code',
    set_success: 'Verified, please click here',
    languageText: 'Language',
    verifyCode: 'Verification Code',
    agreeSend: 'Agree to receive House730 member news',
    cantSpace: 'Cannot include',
    linkPhone: 'Mobile Phone',
    error: 'Error or invalidation',
    accountStatus: 'Account status',
    noTrue: 'Pending confirmation, please check your mailbox and verifiy your email address',
    goLogin: 'Account Login',
    hasPass: 'Fail to verify, verification already done',
    waitSend: 'Click "send" button to receive confirmation email for verification',
    findPwd: 'Find Password',
    confirm: ' Confirmation',
    verifyError: 'Verification code is invalid, please try again',
    networkError: 'Network unstable, please try again',
    certificate: 'Estate Agent Card',
    wepUpdata: 'Upload',
    pcUpdata: 'Upload Photo',
    imagePath: 'Image',
    promptMessage: 'After uploading the Estate Agent Card, it cannot be edited. Please contact us if you need amendment',
    errorImg: 'Please upload png, jpg, jpeg format',
    imgfailure: 'Real estate agent certificate failed to upload',
    imgNull:"Picture cannot be empty",
  }
};
export default language[type];
